<template>
  <button class="button" :class="`button-color--${color}`"  @click="$emit('click', $event)">
    Test 2: <slot></slot>
  </button>
</template>

<script>
  export default {
    name: 'solid-button',
    props: {
      color: {
        type: String,
        default: 'normal', // 'normal' or 'primary'
      },
    }
  };
</script>